module.exports = __webpack_public_path__ + "static/media/team_8.ff8f0d05.jpg";